// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1vxCZ","header":"MessagesList_header__viR0v","chat":"MessagesList_chat__2T5kR"};